import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';
import Personalizer from 'personalizer';
import PrivacyAlertModalView from 'views/privacy/PrivacyAlertModalView';
import PrivacyAlertView from 'views/privacy/PrivacyAlertView';

var PrivacyAlertUtil = {
    renderPrivacyAlert: function(userProfile, userPreferences, requestType) {
        this.privacyAlertView = new PrivacyAlertView({
            requestType: requestType
        });

        this.privacyAlertView.on(PrivacyAlertView.Events.Closed, this.closeModal, this);
        this.privacyAlertView.on(PrivacyAlertView.Events.Ready, this.openModal, this);
    },

    openModal: function() {
        if (this.privacyAlertView.getDisplayModal()) {
            this.modalView = new PrivacyAlertModalView({
                view: this.privacyAlertView,
                showFooter: true,
                modalTitle: Localizer.localize('privacy.alert.heading')
            });

            this.modalView.on(PrivacyAlertModalView.Events.ON_SAVE, this.onSavePrivacyClicked, this);
            this.modalView.render();
            this.privacyAlertView.disableSaveOption(true);
        }
    },

    closeModal: function() {
        this.modalView.close();
    },

    onSavePrivacyClicked: function() {
        this.privacyAlertView.onSaveClicked();
    }
};

export default PrivacyAlertUtil;
